const Switch = props => {
  const { checked, onChange } = props;

  const handleClick = () => {
    onChange?.();
  };

  return (
    <div
      style={
        checked
          ? { background: '#006AFF' }
          : {}
      }
      className={[
        'cursor-pointer',
        'h-[16px] w-[29px]',
        'rounded-full p-[2px]',
        'bg-[rgba(0,0,0,0.2)] ring-1 ring-inset ring-slate-900/5',
        'transition duration-200 ease-in-out',
      ]}
      onClick={handleClick}
    >
      <div
        className={[
          'h-[12px] w-[12px]',
          'rounded-full bg-white shadow-sm ring-1 ring-slate-700/10',
          'transition-transform duration-200 ease-in-out transform-gpu',
          { 'translate-x-[13px]': checked },
        ]}
      ></div>
    </div>
  );
};

export default Switch;
